export default function () {
  const moduleName = 'popUp'

  Element.prototype.isVisible = function () {
    const element = this
    return element.offsetParent !== null
  }

  const activePopUp = []

  /**
   * Events-start
   */

  window.addEventListener('resize', () => {
    if (activePopUp.length) {
      centeringPopUp(activePopUp[activePopUp.length - 1])
    }
  })

  document.addEventListener('keydown', (event) => {
    if (event.keyCode === 27 && activePopUp.length) {
      event.preventDefault()

      hidePopUp((activePopUp[activePopUp.length - 1]))
    }
  })

  /**
   * Events-end
   */

  /**
   * Functions-start
   */

  window.showPopUp = (popUpId) => {
    const popUp = document.querySelector('#' + popUpId)

    if (!(popUp.classList.contains('active'))) {
      showPopUp(popUp)
    }
  }

  function showPopUp (popUp, popUpBtnOpen) {
    const url = popUp.dataset.url
    const hasOnclick = popUpBtnOpen ? popUpBtnOpen.getAttribute('onclick') : undefined

    if (url) {
      getPopUpByAjaxAndInsert(popUp, url)
    }

    if (hasOnclick) {
      popUp.innerHTML = ''
      popUp.classList.add('loading')
    }

    popUp.classList.add('active')

    if (!url && !hasOnclick) {
      putFocusOnTheFirstInput(popUp)
    }

    if (!url && !hasOnclick) {
      centeringPopUp(popUp)
    }

    activePopUp.push(popUp)
  }

  function hidePopUp (popUp) {
    popUp.classList.remove('active')

    activePopUp.splice(activePopUp.indexOf(popUp), 1)
  }

  function getPopUpByAjaxAndInsert (popUp, url) {
    const formData = new FormData()
    const xhr = new XMLHttpRequest()

    formData.append('id', popUp.getAttribute('id'))

    popUp.innerHTML = ''
    popUp.classList.add('loading')

    xhr.open('POST', url)
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        popUp.innerHTML = xhr.responseText

        putFocusOnTheFirstInput(popUp)
        centeringPopUp(popUp)

        popUp.classList.remove('loading')

        callOtherModules()
      }
    }
    xhr.send(formData)
  }

  function putFocusOnTheFirstInput (popUp) {
    if (popUp.dataset.popUpPutFocus === 'false') return

    setTimeout(() => {
      if (!(document.body.classList.contains('mobile'))) {
        Array.from(popUp.querySelectorAll('input, textarea')).every((input) => {
          if (input.isVisible() && input.value === '') {
            input.focus()
            return false
          } else {
            return true
          }
        })
      }
    }, 200)
  }

  function centeringPopUp (popUp) {
    if (!popUp.querySelector('.js-pop-up-insides')) return

    centeringPopUpAfterLoadingImages(popUp)

    const scrollTop = document.documentElement.scrollTop
    const windowHeight = window.innerHeight
    const popUpInsides = popUp.querySelector('.js-pop-up-insides')
    const popUpInsidesHeight = popUpInsides.offsetHeight

    if (popUpInsidesHeight > windowHeight) {
      popUp.style.top = scrollTop + 40 + 'px'
    } else {
      popUp.style.top = scrollTop + ((windowHeight - popUpInsidesHeight) / 2) + 'px'
    }
  }

  function centeringPopUpAfterLoadingImages (popUp) {
    const notUploadedImagesInPopUp = Array.from(popUp.querySelectorAll('img')).filter(image => !image.complete)

    if (!notUploadedImagesInPopUp.length) return

    Array.from(notUploadedImagesInPopUp).forEach((imageInPopUp) => {
      const image = new Image()

      image.onload = () => {
        centeringPopUp(popUp)
      }

      image.src = imageInPopUp.getAttribute('src')
    })
  }

  function callOtherModules () {

  }

  /**
   * Functions-end
   */

  Array.from(document.querySelectorAll('.js-pop-up')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    const popUp = wrapper

    popUp.addEventListener('click', (event) => {
      const btnClose = event.target.closest('.js-pop-up-btn-close')
      if (!btnClose) return

      event.preventDefault()
      event.stopPropagation()

      hidePopUp(popUp)
    })

    popUp.addEventListener('click', (event) => {
      const insides = event.target.closest('.js-pop-up-insides')
      if (insides) return

      event.stopPropagation()

      hidePopUp(popUp)
    })

    new MutationObserver(() => {
      putFocusOnTheFirstInput(popUp)
      centeringPopUp(popUp)
      callOtherModules()

      popUp.classList.remove('loading')
    }).observe(popUp, {
      childList: true,
      characterData: true,
      subtree: true
    })

    const search = window.location.search.replace('?', '')

    if (search.indexOf('pop-up-') !== -1) {
      window.showPopUp(search)
    }
  })

  Array.from(document.querySelectorAll('.js-pop-up-btn-open')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    const popUpBtnOpen = wrapper

    popUpBtnOpen.addEventListener('click', (event) => {
      const btnOpen = event.target.closest('.js-pop-up-btn-open')
      if (!btnOpen) return

      event.preventDefault()

      const popUpId = btnOpen.dataset.popUpId
      const popUp = document.querySelector('#' + popUpId)

      showPopUp(popUp, popUpBtnOpen)
    })
  })
};
